import { Zap } from "lucide-react";
import { snapSla } from "@/lib/sla";

export const SnapSla = ({ lead, showLabel = false }) => {
  const s = snapSla(lead);
  if (!s) return null;
  return (
    <span
      data-testid={`snap-sla-${s.level}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold ${s.anim}`}
      style={{ backgroundColor: s.color + "22", color: s.color, border: `1px solid ${s.color}` }}
      title={`SNAP — ${s.label}`}
    >
      <Zap className="h-3.5 w-3.5" /> {showLabel ? s.label : `${Math.floor(s.hours)}h`}
    </span>
  );
};
